"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var AbstractFilterHash_1 = require("./AbstractFilterHash");
/**
 * A comunica Hash Query Operation Actor.
 */


var AbstractBindingHash =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(AbstractBindingHash, _bus_query_operation_);

  function AbstractBindingHash(args, operator) {
    var _this;

    _classCallCheck(this, AbstractBindingHash);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractBindingHash).call(this, args, operator));

    if (!AbstractFilterHash_1.AbstractFilterHash.doesHashAlgorithmExist(_this.hashAlgorithm)) {
      throw new Error("The given hash algorithm is not present in this version of Node: " + _this.hashAlgorithm);
    }

    if (!AbstractFilterHash_1.AbstractFilterHash.doesDigestAlgorithmExist(_this.digestAlgorithm)) {
      throw new Error("The given digest algorithm is not present in this version of Node: " + _this.digestAlgorithm);
    }

    return _this;
  }

  _createClass(AbstractBindingHash, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pattern, context) {
        var output, bindingsStream;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = bus_query_operation_1.ActorQueryOperation;
                _context2.next = 3;
                return this.mediatorQueryOperation.mediate({
                  operation: pattern.input,
                  context: context
                });

              case 3:
                _context2.t1 = _context2.sent;
                output = _context2.t0.getSafeBindings.call(_context2.t0, _context2.t1);
                bindingsStream = output.bindingsStream.filter(this.newHashFilter(this.hashAlgorithm, this.digestAlgorithm));
                return _context2.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  metadata: output.metadata,
                  variables: output.variables
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return AbstractBindingHash;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.AbstractBindingHash = AbstractBindingHash;